module.exports = __webpack_public_path__ + "static/media/logo-buy-more-coin.efeea671.png";